import { IGNORE_SEARCH_TAB, SEARCH_ABLE_TAB } from './config';

const DefaultSearch = ({ activeTab }: { activeTab: string }) => {
  if (IGNORE_SEARCH_TAB.includes(activeTab)) {
    return null;
  }

  return SEARCH_ABLE_TAB[activeTab] || SEARCH_ABLE_TAB.default;
};

export default DefaultSearch;
